import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import BasicRouter from "./incs/BasicRouter";

ReactDOM.createRoot(document.getElementById("root")).render(
	<RouterProvider router={BasicRouter} />
);